import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevicesLightInline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 506,
	height: 84,
	viewBox: "0 0 506 84",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M310.199 64.1337C310.71 64.1337 311.123 64.5489 311.123 65.0624",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.274 65.0619C309.274 64.5484 309.687 64.1333 310.198 64.1333",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M310.199 65.9938C309.689 65.9938 309.276 65.5786 309.276 65.0615",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M311.123 65.0619C311.123 65.579 310.71 65.9941 310.199 65.9941",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M300.413 15.2709H319.974C324.296 15.2709 327.799 18.7923 327.799 23.1331V66.3988C327.799 70.7395 324.296 74.2609 319.974 74.2609H300.413C296.091 74.2609 292.589 70.7395 292.589 66.3988V23.1331C292.589 18.7923 296.091 15.2709 300.413 15.2709Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.425 70.6494C237.828 70.6494 238.154 71.0026 238.154 71.4364",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.689 71.4353C236.689 71.0016 237.018 70.6483 237.421 70.6483",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.421 72.222C237.018 72.222 236.689 71.8687 236.689 71.4349",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.154 71.4353C238.154 71.8691 237.828 72.2224 237.425 72.2224",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M255.742 76.6163C258.879 76.6163 261.421 74.204 261.421 71.2355L261.385 20.0901C261.385 17.1188 258.843 14.7094 255.707 14.7094H218.799C215.662 14.7094 213.121 17.1188 213.121 20.0901V71.2355C213.121 74.204 215.662 76.6163 218.799 76.6163H255.742Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.338 57.4737V26.1092C121.338 23.897 122.913 22.1053 124.857 22.1053H175.293C177.234 22.1053 178.812 23.897 178.812 26.1092V57.4737",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M156.081 57.5941H182.557V58.1724C182.557 62.0033 179.371 64.1053 175.444 64.1053H124.466C120.536 64.1053 117.352 62.0033 117.352 58.1724V57.5941H143.826L143.814 57.5681V58.82C143.814 59.2653 144.184 59.6267 144.644 59.6267H155.15C155.61 59.6267 155.98 59.2653 155.98 58.82V57.5681L156.081 57.5941Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M359.412 46.3791V61.1741C359.412 67.2614 364.416 72.1949 370.59 72.1949H404.124C410.298 72.1949 415.301 67.2614 415.301 61.1741V46.3791",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M403.685 17.0905H371.026C367.374 17.0905 364.244 19.6702 363.596 23.2131L359.597 44.3322C358.479 50.4005 362.561 56.2157 368.716 57.3205C369.384 57.4402 370.062 57.5001 370.741 57.5001H403.969C410.226 57.5001 415.299 52.4985 415.296 46.3296C415.296 45.6602 415.238 44.9908 415.117 44.3322L411.117 23.2077C410.466 19.6647 407.336 17.0905 403.685 17.0905Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M379.942 36.2796C379.954 34.6537 380.42 33.2497 381.563 32.1416C382.221 31.508 382.901 31.1046 383.601 30.9218C384.295 30.7405 385.056 30.7638 385.905 31.0557C386.077 31.1155 386.237 31.1717 386.385 31.224C386.761 31.356 387.066 31.463 387.313 31.539C387.667 31.6479 387.988 31.721 388.333 31.7101C388.674 31.6993 388.979 31.6074 389.296 31.4975C389.434 31.4493 389.567 31.4009 389.711 31.348C389.94 31.2641 390.201 31.1688 390.567 31.0449L390.568 31.0445C392.434 30.4099 394.185 30.8077 395.362 31.9723C393.905 33.2649 393.256 34.9987 393.396 36.6903C393.539 38.4119 394.497 40.0371 396.143 41.0621C395.811 41.9304 395.358 42.753 394.809 43.5367C394.42 44.0835 393.968 44.6132 393.486 45.1134C392.917 45.7004 392.219 45.7971 391.296 45.5039L391.293 45.5029C391.105 45.4439 390.921 45.3787 390.722 45.3081C390.665 45.2881 390.608 45.2677 390.549 45.247C390.289 45.1556 390.006 45.0597 389.709 44.983L389.709 44.9829L389.699 44.9804C388.486 44.6845 387.322 44.8846 386.275 45.3457C385.432 45.7166 384.904 45.7616 384.488 45.6433C384.054 45.5198 383.584 45.1758 382.954 44.412C380.99 42.0218 379.931 39.3297 379.942 36.2796ZM391.004 27.1874C390.425 27.8962 389.668 28.4043 388.862 28.5702C388.9 27.9315 389.216 27.1688 389.801 26.4704C390.395 25.7609 391.165 25.2428 391.949 25.0563C391.878 25.7478 391.551 26.5183 391.004 27.1874Z",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M489.296 59.6703C489.296 70.981 479.995 80.1532 468.519 80.1532C457.047 80.1532 447.744 70.981 447.744 59.6703C447.744 48.3574 457.047 39.1852 468.519 39.1852C479.995 39.1852 489.296 48.3574 489.296 59.6703Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M479.957 59.6703C479.957 65.896 474.836 70.9453 468.519 70.9453C462.205 70.9453 457.083 65.896 457.083 59.6703C457.083 53.4424 462.205 48.3931 468.519 48.3931C474.836 48.3931 479.957 53.4424 479.957 59.6703Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M472.563 59.6701C472.563 61.8711 470.751 63.6591 468.517 63.6591C466.284 63.6591 464.471 61.8711 464.471 59.6701C464.471 57.4669 466.284 55.6811 468.517 55.6811C470.751 55.6811 472.563 57.4669 472.563 59.6701Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M472.086 15.9046V22.1771C472.086 24.0946 470.494 25.6639 468.547 25.6639C466.6 25.6639 465.008 24.0946 465.008 22.1771V15.9046H472.086Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M466.82 13.2042H470.274V10.5054H466.82V13.2042Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M468.536 39.1863V25.8957",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M468.265 55.7033H478.998",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M472.048 61.5954L466.519 70.6158",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M465.452 62.2996L459.471 52.9176",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.80103 15.5969H82.8749C84.9784 15.5969 86.6829 17.1481 86.6829 19.0625V64.1211C86.6829 66.0355 84.9784 67.5867 82.8749 67.5867H4.80103C2.70089 67.5867 0.993042 66.0355 0.993042 64.1211V19.0625C0.993042 17.1481 2.70089 15.5969 4.80103 15.5969Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8714 67.5867L11.3797 74.0854",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.1029 67.5867L77.5945 74.0854",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgDevicesLightInline as ReactComponent };
